var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tree-node"},[_c('node-content',{staticClass:"tree-node-content"}),_c('div',{staticClass:"tree-node-children"},_vm._l((_vm.nodeData.children),function(child,idx){return _c('tree-node',{key:idx,attrs:{"nodeData":child,"id":child.id}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }